
// --- OFFENSE 5v5 ---
export const OFFENSE_FORMATIONS_5v5 = {
    "Spread (2x1 + RB)": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "X", x: 15, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "WR", tag: "Z", x: 85, y: 70, speed: 5.4 },
        { id: 5, type: "offense", role: "RB", tag: "RB", x: 60, y: 82, speed: 5.45 },
    ],

    "Trips Right (3x0)": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "SL", tag: "H", x: 60, y: 70, speed: 5.5 },
        { id: 4, type: "offense", role: "WR", tag: "Y", x: 75, y: 70, speed: 5.4 },
        { id: 5, type: "offense", role: "WR", tag: "Z", x: 90, y: 70, speed: 5.4 },
    ],

    "Bunch Right": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "X", x: 20, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "WR", tag: "Z", x: 78, y: 70, speed: 5.4 },
        { id: 5, type: "offense", role: "SL", tag: "H", x: 72, y: 74, speed: 5.5 },
    ],

    "Bunch Left": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "Z", x: 80, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "WR", tag: "X", x: 22, y: 70, speed: 5.4 },
        { id: 5, type: "offense", role: "SL", tag: "H", x: 15, y: 74, speed: 5.5 },
    ],

    "Stack Right": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "X", x: 20, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "WR", tag: "Z", x: 80, y: 70, speed: 5.4 },
        { id: 5, type: "offense", role: "SL", tag: "H", x: 80, y: 76, speed: 5.5 },
    ],

    "Stack Left": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "X", x: 20, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "WR", tag: "Z", x: 80, y: 70, speed: 5.4 },
        { id: 5, type: "offense", role: "SL", tag: "H", x: 20, y: 76, speed: 5.5 },
    ],

    "Diamond": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 76, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "RB", tag: "L", x: 42, y: 76, speed: 5.45 },
        { id: 4, type: "offense", role: "RB", tag: "R", x: 58, y: 76, speed: 5.45 },
        { id: 5, type: "offense", role: "RB", tag: "T", x: 50, y: 82, speed: 5.45 },
    ],
};

// --- DEFENSE 5v5 ---
export const DEFENSE_FORMATIONS_5v5 = {
    "2-2-1 (Balanced Zone)": [
        { id: 101, type: "defense", role: "DEF", tag: "R", x: 50, y: 66, speed: 5.5 },
        { id: 102, type: "defense", role: "DEF", tag: "LF", x: 25, y: 56, speed: 5.3 },
        { id: 103, type: "defense", role: "DEF", tag: "RF", x: 75, y: 56, speed: 5.3 },
        { id: 104, type: "defense", role: "DEF", tag: "M", x: 50, y: 52, speed: 5.2 },
        { id: 105, type: "defense", role: "DEF", tag: "S", x: 50, y: 40, speed: 5.1 },
    ],

    "1-3-1 (Strong Under)": [
        { id: 101, type: "defense", role: "DEF", tag: "R", x: 50, y: 66, speed: 5.5 },
        { id: 102, type: "defense", role: "DEF", tag: "L", x: 20, y: 56, speed: 5.3 },
        { id: 103, type: "defense", role: "DEF", tag: "M", x: 50, y: 54, speed: 5.3 },
        { id: 104, type: "defense", role: "DEF", tag: "RF", x: 80, y: 56, speed: 5.3 },
        { id: 105, type: "defense", role: "DEF", tag: "S", x: 50, y: 40, speed: 5.1 },
    ],

    "Cover 2-ish (2 Deep / 2 Under / Rush)": [
        { id: 101, type: "defense", role: "DEF", tag: "R", x: 50, y: 66, speed: 5.5 },
        { id: 102, type: "defense", role: "DEF", tag: "LF", x: 25, y: 56, speed: 5.3 },
        { id: 103, type: "defense", role: "DEF", tag: "RF", x: 75, y: 56, speed: 5.3 },
        { id: 104, type: "defense", role: "DEF", tag: "LS", x: 30, y: 42, speed: 5.1 },
        { id: 105, type: "defense", role: "DEF", tag: "RS", x: 70, y: 42, speed: 5.1 },
    ],

    "Man (Across)": [
        { id: 101, type: "defense", role: "DEF", tag: "R", x: 50, y: 66, speed: 5.5 },
        { id: 102, type: "defense", role: "DEF", tag: "M1", x: 20, y: 60, speed: 5.2 },
        { id: 103, type: "defense", role: "DEF", tag: "M2", x: 80, y: 60, speed: 5.2 },
        { id: 104, type: "defense", role: "DEF", tag: "M3", x: 40, y: 58, speed: 5.2 },
        { id: 105, type: "defense", role: "DEF", tag: "FS", x: 60, y: 44, speed: 5.1 },
    ],
};

// --- OFFENSE 6v6 ---
export const OFFENSE_FORMATIONS_6v6 = {
    "Spread (2x1 + Slot + RB)": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "X", x: 15, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "WR", tag: "Z", x: 85, y: 70, speed: 5.4 },
        { id: 5, type: "offense", role: "SL", tag: "H", x: 35, y: 70, speed: 5.5 },
        { id: 6, type: "offense", role: "RB", tag: "RB", x: 60, y: 82, speed: 5.45 },
    ],

    "Trips Right (3x1)": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "X", x: 15, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "SL", tag: "H", x: 60, y: 70, speed: 5.5 },
        { id: 5, type: "offense", role: "WR", tag: "Y", x: 75, y: 70, speed: 5.4 },
        { id: 6, type: "offense", role: "WR", tag: "Z", x: 90, y: 70, speed: 5.4 },
    ],

    "Trips Left (3x1)": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "X", x: 85, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "WR", tag: "Z", x: 10, y: 70, speed: 5.4 },
        { id: 5, type: "offense", role: "WR", tag: "Y", x: 25, y: 70, speed: 5.4 },
        { id: 6, type: "offense", role: "SL", tag: "H", x: 40, y: 70, speed: 5.5 },
    ],

    "Bunch Right": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "X", x: 15, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "WR", tag: "Z", x: 78, y: 70, speed: 5.4 },
        { id: 5, type: "offense", role: "SL", tag: "H", x: 72, y: 74, speed: 5.5 },
        { id: 6, type: "offense", role: "WR", tag: "Y", x: 85, y: 74, speed: 5.4 },
    ],

    "Bunch Left": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "Z", x: 85, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "WR", tag: "X", x: 22, y: 70, speed: 5.4 },
        { id: 5, type: "offense", role: "SL", tag: "H", x: 15, y: 74, speed: 5.5 },
        { id: 6, type: "offense", role: "WR", tag: "Y", x: 28, y: 74, speed: 5.4 },
    ],

    "Stack (2x2 Stack)": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "X", x: 25, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "SL", tag: "H", x: 25, y: 76, speed: 5.5 },
        { id: 5, type: "offense", role: "WR", tag: "Z", x: 75, y: 70, speed: 5.4 },
        { id: 6, type: "offense", role: "SL", tag: "Y", x: 75, y: 76, speed: 5.5 },
    ],

    "Tight (Compressed)": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "SL", tag: "H", x: 42, y: 70, speed: 5.5 },
        { id: 4, type: "offense", role: "SL", tag: "Y", x: 58, y: 70, speed: 5.5 },
        { id: 5, type: "offense", role: "WR", tag: "X", x: 20, y: 70, speed: 5.4 },
        { id: 6, type: "offense", role: "WR", tag: "Z", x: 80, y: 70, speed: 5.4 },
    ],

    "I-Formation": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "X", x: 20, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "WR", tag: "Z", x: 80, y: 70, speed: 5.4 },
        { id: 5, type: "offense", role: "SL", tag: "H", x: 35, y: 70, speed: 5.5 },
        { id: 6, type: "offense", role: "RB", tag: "RB", x: 50, y: 84, speed: 5.45 },
    ],

    "Shotgun": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "X", x: 15, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "WR", tag: "Z", x: 85, y: 70, speed: 5.4 },
        { id: 5, type: "offense", role: "SL", tag: "H", x: 35, y: 70, speed: 5.5 },
        { id: 6, type: "offense", role: "RB", tag: "RB", x: 60, y: 82, speed: 5.45 },
    ],

    "Singleback": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 74, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "X", x: 15, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "WR", tag: "Z", x: 85, y: 70, speed: 5.4 },
        { id: 5, type: "offense", role: "SL", tag: "H", x: 35, y: 70, speed: 5.5 },
        { id: 6, type: "offense", role: "RB", tag: "RB", x: 50, y: 82, speed: 5.45 },
    ],

    "Empty": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "X", x: 15, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "WR", tag: "Z", x: 85, y: 70, speed: 5.4 },
        { id: 5, type: "offense", role: "SL", tag: "H", x: 35, y: 70, speed: 5.5 },
        { id: 6, type: "offense", role: "SL", tag: "Y", x: 65, y: 70, speed: 5.5 },
    ],

    "Pistol": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 76, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "X", x: 15, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "WR", tag: "Z", x: 85, y: 70, speed: 5.4 },
        { id: 5, type: "offense", role: "SL", tag: "H", x: 35, y: 72, speed: 5.5 },
        { id: 6, type: "offense", role: "RB", tag: "RB", x: 50, y: 82, speed: 5.45 },
    ],

    "Wildcat": [
        { id: 1, type: "offense", role: "RB", tag: "RB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "QB", tag: "QB", x: 25, y: 70, speed: 5.5 },
        { id: 4, type: "offense", role: "WR", tag: "X", x: 10, y: 70, speed: 5.4 },
        { id: 5, type: "offense", role: "WR", tag: "Z", x: 90, y: 70, speed: 5.4 },
        { id: 6, type: "offense", role: "SL", tag: "H", x: 70, y: 70, speed: 5.5 },
    ],

    "Victory Formation": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 74, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "G", x: 44, y: 71, speed: 5.2 },
        { id: 4, type: "offense", role: "WR", tag: "G", x: 56, y: 71, speed: 5.2 },
        { id: 5, type: "offense", role: "RB", tag: "RB", x: 50, y: 77, speed: 5.45 },
        { id: 6, type: "offense", role: "SL", tag: "FB", x: 60, y: 76, speed: 5.3 },
    ],
};

// --- DEFENSE 6v6 ---
export const DEFENSE_FORMATIONS_6v6 = {
    "2-3-1 (Balanced Zone)": [
        { id: 101, type: "defense", role: "DEF", tag: "R", x: 50, y: 66, speed: 5.5 },
        { id: 102, type: "defense", role: "DEF", tag: "LF", x: 22, y: 56, speed: 5.3 },
        { id: 103, type: "defense", role: "DEF", tag: "M", x: 50, y: 54, speed: 5.3 },
        { id: 104, type: "defense", role: "DEF", tag: "RF", x: 78, y: 56, speed: 5.3 },
        { id: 105, type: "defense", role: "DEF", tag: "LS", x: 35, y: 42, speed: 5.1 },
        { id: 106, type: "defense", role: "DEF", tag: "RS", x: 65, y: 42, speed: 5.1 }
    ],

    "3-2-1 (Aggressive Under)": [
        { id: 101, type: "defense", role: "DEF", tag: "R", x: 50, y: 66, speed: 5.5 },
        { id: 102, type: "defense", role: "DEF", tag: "LU", x: 30, y: 56, speed: 5.3 },
        { id: 103, type: "defense", role: "DEF", tag: "RU", x: 70, y: 56, speed: 5.3 },
        { id: 104, type: "defense", role: "DEF", tag: "M", x: 50, y: 52, speed: 5.2 },
        { id: 105, type: "defense", role: "DEF", tag: "LS", x: 30, y: 42, speed: 5.1 },
        { id: 106, type: "defense", role: "DEF", tag: "RS", x: 70, y: 42, speed: 5.1 }
    ],

    "Cover 2 (2 Deep / 3 Under)": [
        { id: 101, type: "defense", role: "DEF", tag: "R", x: 50, y: 66, speed: 5.5 },
        { id: 102, type: "defense", role: "DEF", tag: "LF", x: 25, y: 56, speed: 5.3 },
        { id: 103, type: "defense", role: "DEF", tag: "M", x: 50, y: 54, speed: 5.3 },
        { id: 104, type: "defense", role: "DEF", tag: "RF", x: 75, y: 56, speed: 5.3 },
        { id: 105, type: "defense", role: "DEF", tag: "LS", x: 30, y: 42, speed: 5.1 },
        { id: 106, type: "defense", role: "DEF", tag: "RS", x: 70, y: 42, speed: 5.1 }
    ],

    "Cover 3 (3 Deep / 2 Under + Rush)": [
        { id: 101, type: "defense", role: "DEF", tag: "R", x: 50, y: 66, speed: 5.5 },
        { id: 102, type: "defense", role: "DEF", tag: "LH", x: 40, y: 56, speed: 5.3 },
        { id: 103, type: "defense", role: "DEF", tag: "RH", x: 60, y: 56, speed: 5.3 },
        { id: 104, type: "defense", role: "DEF", tag: "L3", x: 20, y: 44, speed: 5.1 },
        { id: 105, type: "defense", role: "DEF", tag: "M3", x: 50, y: 40, speed: 5.1 },
        { id: 106, type: "defense", role: "DEF", tag: "R3", x: 80, y: 44, speed: 5.1 }
    ],

    "Man Free (1 High)": [
        { id: 101, type: "defense", role: "DEF", tag: "R", x: 50, y: 66, speed: 5.5 },
        { id: 102, type: "defense", role: "DEF", tag: "M1", x: 20, y: 60, speed: 5.2 },
        { id: 103, type: "defense", role: "DEF", tag: "M2", x: 80, y: 60, speed: 5.2 },
        { id: 104, type: "defense", role: "DEF", tag: "M3", x: 40, y: 58, speed: 5.2 },
        { id: 105, type: "defense", role: "DEF", tag: "M4", x: 60, y: 58, speed: 5.2 },
        { id: 106, type: "defense", role: "DEF", tag: "FS", x: 50, y: 40, speed: 5.1 }
    ],

    "Double Rush": [
        { id: 101, type: "defense", role: "DEF", tag: "R1", x: 45, y: 66, speed: 5.5 },
        { id: 102, type: "defense", role: "DEF", tag: "R2", x: 55, y: 66, speed: 5.5 },
        { id: 103, type: "defense", role: "DEF", tag: "LF", x: 25, y: 56, speed: 5.3 },
        { id: 104, type: "defense", role: "DEF", tag: "RF", x: 75, y: 56, speed: 5.3 },
        { id: 105, type: "defense", role: "DEF", tag: "S", x: 50, y: 42, speed: 5.1 },
    ],
};

// --- OFFENSE 7v7 ---
export const OFFENSE_FORMATIONS_7v7 = {
    "Doubles (2x2)": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "X", x: 15, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "WR", tag: "Z", x: 85, y: 70, speed: 5.4 },
        { id: 5, type: "offense", role: "SL", tag: "H", x: 35, y: 70, speed: 5.5 },
        { id: 6, type: "offense", role: "SL", tag: "Y", x: 65, y: 70, speed: 5.5 },
        { id: 7, type: "offense", role: "RB", tag: "RB", x: 60, y: 82, speed: 5.45 },
    ],

    "Trips Right (3x1)": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "X", x: 15, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "SL", tag: "H", x: 60, y: 70, speed: 5.5 },
        { id: 5, type: "offense", role: "WR", tag: "Y", x: 75, y: 70, speed: 5.4 },
        { id: 6, type: "offense", role: "WR", tag: "Z", x: 90, y: 70, speed: 5.4 },
        { id: 7, type: "offense", role: "RB", tag: "RB", x: 40, y: 82, speed: 5.45 },
    ],

    "Trips Left (3x1)": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "X", x: 85, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "WR", tag: "Z", x: 10, y: 70, speed: 5.4 },
        { id: 5, type: "offense", role: "WR", tag: "Y", x: 25, y: 70, speed: 5.4 },
        { id: 6, type: "offense", role: "SL", tag: "H", x: 40, y: 70, speed: 5.5 },
        { id: 7, type: "offense", role: "RB", tag: "RB", x: 60, y: 82, speed: 5.45 },
    ],

    "Bunch Right": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "X", x: 15, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "WR", tag: "Z", x: 78, y: 70, speed: 5.4 },
        { id: 5, type: "offense", role: "SL", tag: "H", x: 72, y: 74, speed: 5.5 },
        { id: 6, type: "offense", role: "WR", tag: "Y", x: 85, y: 74, speed: 5.4 },
        { id: 7, type: "offense", role: "RB", tag: "RB", x: 60, y: 82, speed: 5.45 },
    ],

    "Bunch Left": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "X", x: 85, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "WR", tag: "Z", x: 22, y: 70, speed: 5.4 },
        { id: 5, type: "offense", role: "SL", tag: "H", x: 15, y: 74, speed: 5.5 },
        { id: 6, type: "offense", role: "WR", tag: "Y", x: 28, y: 74, speed: 5.4 },
        { id: 7, type: "offense", role: "RB", tag: "RB", x: 40, y: 82, speed: 5.45 },
    ],

    "Stack (2x2 Stack)": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "X", x: 25, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "SL", tag: "H", x: 25, y: 76, speed: 5.5 },
        { id: 5, type: "offense", role: "WR", tag: "Z", x: 75, y: 70, speed: 5.4 },
        { id: 6, type: "offense", role: "SL", tag: "Y", x: 75, y: 76, speed: 5.5 },
        { id: 7, type: "offense", role: "RB", tag: "RB", x: 60, y: 82, speed: 5.45 },
    ],

    "Empty Spread (3x2)": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "SL", tag: "H", x: 60, y: 70, speed: 5.5 },
        { id: 4, type: "offense", role: "WR", tag: "Y", x: 75, y: 70, speed: 5.4 },
        { id: 5, type: "offense", role: "WR", tag: "Z", x: 90, y: 70, speed: 5.4 },
        { id: 6, type: "offense", role: "WR", tag: "X", x: 10, y: 70, speed: 5.4 },
        { id: 7, type: "offense", role: "SL", tag: "H2", x: 30, y: 70, speed: 5.5 },
    ],

    "Tight (Compressed)": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "SL", tag: "H", x: 40, y: 70, speed: 5.5 },
        { id: 4, type: "offense", role: "SL", tag: "Y", x: 60, y: 70, speed: 5.5 },
        { id: 5, type: "offense", role: "WR", tag: "X", x: 20, y: 70, speed: 5.4 },
        { id: 6, type: "offense", role: "WR", tag: "Z", x: 80, y: 70, speed: 5.4 },
        { id: 7, type: "offense", role: "RB", tag: "RB", x: 60, y: 82, speed: 5.45 },
    ],

    "Quads Right": [
        { id: 1, type: "offense", role: "QB", tag: "QB", x: 50, y: 80, speed: 5.5 },
        { id: 2, type: "offense", role: "C", tag: "C", x: 50, y: 70, speed: 5.7 },
        { id: 3, type: "offense", role: "WR", tag: "X", x: 15, y: 70, speed: 5.4 },
        { id: 4, type: "offense", role: "SL", tag: "H", x: 65, y: 70, speed: 5.5 },
        { id: 5, type: "offense", role: "SL", tag: "Y", x: 75, y: 70, speed: 5.5 },
        { id: 6, type: "offense", role: "WR", tag: "Z", x: 85, y: 70, speed: 5.4 },
        { id: 7, type: "offense", role: "SL", tag: "W", x: 55, y: 70, speed: 5.5 },
    ],
};

// --- DEFENSE 7v7 ---
export const DEFENSE_FORMATIONS_7v7 = {
    "Cover 2 Shell (2D/5U)": [
        { id: 101, type: "defense", role: "DEF", tag: "R", x: 50, y: 66, speed: 5.5 },
        { id: 102, type: "defense", role: "DEF", tag: "LF", x: 20, y: 58, speed: 5.2 },
        { id: 103, type: "defense", role: "DEF", tag: "LH", x: 40, y: 56, speed: 5.3 },
        { id: 104, type: "defense", role: "DEF", tag: "RH", x: 60, y: 56, speed: 5.3 },
        { id: 105, type: "defense", role: "DEF", tag: "RF", x: 80, y: 58, speed: 5.2 },
        { id: 106, type: "defense", role: "DEF", tag: "M", x: 50, y: 54, speed: 5.2 },
        { id: 107, type: "defense", role: "DEF", tag: "LS", x: 30, y: 42, speed: 5.1 },
        { id: 108, type: "defense", role: "DEF", tag: "RS", x: 70, y: 42, speed: 5.1 },
    ],

    "Cover 3 (3D/4U)": [
        { id: 101, type: "defense", role: "DEF", tag: "R", x: 50, y: 66, speed: 5.5 },
        { id: 102, type: "defense", role: "DEF", tag: "LF", x: 25, y: 58, speed: 5.2 },
        { id: 103, type: "defense", role: "DEF", tag: "LH", x: 45, y: 56, speed: 5.3 },
        { id: 104, type: "defense", role: "DEF", tag: "RH", x: 55, y: 56, speed: 5.3 },
        { id: 105, type: "defense", role: "DEF", tag: "RF", x: 75, y: 58, speed: 5.2 },
        { id: 106, type: "defense", role: "DEF", tag: "L3", x: 15, y: 44, speed: 5.1 },
        { id: 107, type: "defense", role: "DEF", tag: "M3", x: 50, y: 40, speed: 5.1 },
        { id: 108, type: "defense", role: "DEF", tag: "R3", x: 85, y: 44, speed: 5.1 },
    ],

    "3-Under 4-Deep": [
        { id: 101, type: "defense", role: "DEF", tag: "R", x: 50, y: 66, speed: 5.5 },
        { id: 102, type: "defense", role: "DEF", tag: "LU", x: 30, y: 56, speed: 5.3 },
        { id: 103, type: "defense", role: "DEF", tag: "MU", x: 50, y: 54, speed: 5.3 },
        { id: 104, type: "defense", role: "DEF", tag: "RU", x: 70, y: 56, speed: 5.3 },
        { id: 105, type: "defense", role: "DEF", tag: "LD", x: 20, y: 44, speed: 5.1 },
        { id: 106, type: "defense", role: "DEF", tag: "LMD", x: 40, y: 42, speed: 5.1 },
        { id: 107, type: "defense", role: "DEF", tag: "RMD", x: 60, y: 42, speed: 5.1 },
        { id: 108, type: "defense", role: "DEF", tag: "RD", x: 80, y: 44, speed: 5.1 },
    ],

    "4-Under 3-Deep": [
        { id: 101, type: "defense", role: "DEF", tag: "R", x: 50, y: 66, speed: 5.5 },
        { id: 102, type: "defense", role: "DEF", tag: "LF", x: 25, y: 58, speed: 5.2 },
        { id: 103, type: "defense", role: "DEF", tag: "LH", x: 45, y: 56, speed: 5.3 },
        { id: 104, type: "defense", role: "DEF", tag: "RH", x: 55, y: 56, speed: 5.3 },
        { id: 105, type: "defense", role: "DEF", tag: "RF", x: 75, y: 58, speed: 5.2 },
        { id: 106, type: "defense", role: "DEF", tag: "L3", x: 20, y: 44, speed: 5.1 },
        { id: 107, type: "defense", role: "DEF", tag: "M3", x: 50, y: 40, speed: 5.1 },
        { id: 108, type: "defense", role: "DEF", tag: "R3", x: 80, y: 44, speed: 5.1 },
    ],

    "Man Free (1 High)": [
        { id: 101, type: "defense", role: "DEF", tag: "R", x: 50, y: 66, speed: 5.5 },
        { id: 102, type: "defense", role: "DEF", tag: "M1", x: 20, y: 60, speed: 5.2 },
        { id: 103, type: "defense", role: "DEF", tag: "M2", x: 80, y: 60, speed: 5.2 },
        { id: 104, type: "defense", role: "DEF", tag: "M3", x: 35, y: 58, speed: 5.2 },
        { id: 105, type: "defense", role: "DEF", tag: "M4", x: 65, y: 58, speed: 5.2 },
        { id: 106, type: "defense", role: "DEF", tag: "M5", x: 50, y: 56, speed: 5.3 },
        { id: 107, type: "defense", role: "DEF", tag: "FS", x: 50, y: 40, speed: 5.1 },
    ],
};

// Export Default (Fallback)
export const FORMATIONS = OFFENSE_FORMATIONS_6v6;

export const FORMATIONS_BY_FORMAT = {
    flag_5v5: { offense: OFFENSE_FORMATIONS_5v5, defense: DEFENSE_FORMATIONS_5v5 },
    flag_6v6: { offense: OFFENSE_FORMATIONS_6v6, defense: DEFENSE_FORMATIONS_6v6 },
    flag_7v7: { offense: OFFENSE_FORMATIONS_7v7, defense: DEFENSE_FORMATIONS_7v7 },
};
